import { AppSidebarLayout } from "../layouts";
import { LlmKeyListByOrg } from "../shared/llm-key";

export const LlmKeysPage = () => {
  return (
    <AppSidebarLayout>
      <LlmKeyListByOrg />
    </AppSidebarLayout>
  );
};
